import React, { useState, useMemo } from "react";
import { useSelector } from "react-redux";
import CarBehindPaceIcon from "assets/svgIcons/AdminDashboard/CarBehindPaceIcon";
import { useTranslation } from "react-i18next";
import MapScreen from "assets/images/map-section.png";
import GraphScreen from "assets/images/graph-section.png";
import { CardMedia, Typography, Card, Modal, Box } from "@mui/material";
import { BoxStyle, ModalHeader } from "assets/css/globle";
import ModalCloseIcon from "assets/svgIcons/ModalCloseIcon";
import { ModalBody, TopBox } from "pages/AdminDashboard/AdminDashboardStyled";
import { useRedirectToPage } from "commonComponents/Navigation";
import { isCarInUse } from "_helperFunctions/isCarInUse";
// Helper function to generate pace description string
const getPaceString = (car) => {
  if (!car?.Car) return { result: "", carNum: "" };

  const { Pace, HolesPlayed, CarNumber } = car.Car;
  let result = "";
  result = `${Math.abs(Pace)} min behind`;

  if (HolesPlayed > 0) {
    result += ` through ${HolesPlayed} hole${HolesPlayed > 1 ? "s" : ""}`;
  }
  return { result, carNum: CarNumber };
};

// Navigation card component
const NavigationCard = ({ title, image, onClickPath, redirectToPage, t }) => (
  <div>
    <p>{t(title)}</p>
    <Card
      sx={{
        maxWidth: 281,
        cursor: "pointer",
        borderRadius: "10px",
        overflow: "hidden",
        marginBottom: title === "Map/Cars" ? "19px" : "0px",
      }}
      onClick={() => redirectToPage(onClickPath)}
    >
      <CardMedia component="img" height="206" image={image} alt={title} />
    </Card>
  </div>
);

export const CarBehindPace = ({ carsBehindPace }) => {
  const [open, setOpen] = useState(false);
  const { t } = useTranslation();
  const redirectToPage = useRedirectToPage();
  const { getCurrentCarsData, siteSettingsData } = useSelector((state) => state?.commonReducers) || [];

  // Memoized car list with pace data
  const carPaceData = useMemo(() => {
    if (!getCurrentCarsData?.length) return [];

    return getCurrentCarsData
      .filter(car => isCarInUse(car?.Car, false, false, false) && Math.abs(car?.Car?.Pace || 0) >= siteSettingsData.WarningThreshold)
      .map(getPaceString)
      .filter(car => car.result);
  }, [getCurrentCarsData]);

  // Modal component
  const CarBehindModal = () => (
    <Modal
      open={open}
      onClose={() => setOpen(false)}
      aria-labelledby="cars-behind-pace-modal"
      aria-describedby="cars-behind-pace-description"
    >
      <Box sx={BoxStyle}>
        <ModalHeader>
          <h2>{t("Cars_Behind_Pace")}</h2>
          <ModalCloseIcon onClick={() => setOpen(false)} />
        </ModalHeader>
        <ModalBody>
          <div className="data-container">
            {carPaceData.length > 0 ? (
              carPaceData.map((car, index) => (
                <React.Fragment key={`car-${car.carNum}-${index}`}>
                  <Typography variant="h6" component="h6">
                    {t("Car") + " " + car.carNum}
                  </Typography>
                  <Typography variant="body1" component="span">
                    - {car.result}
                  </Typography>
                </React.Fragment>
              ))
            ) : (
              <span>{t("No_Cars_Are_Behind_Pace")}</span>
            )}
          </div>
        </ModalBody>
      </Box>
    </Modal>
  );

  return (
    <>
      {CarBehindModal()}
      <TopBox noAfter>
        <div className="box-body" onClick={() => setOpen(true)}>
          <CarBehindPaceIcon />
          <h2 className="bp-heading">{carsBehindPace}</h2>
          <p className="bp-sub-heading">{t("Cars_Behind_Pace")}</p>
        </div>
      </TopBox>
    </>
  );
};
